export default {
    Region: process.env.VUE_APP_REGION || 'ap-northeast-1',
    UserPoolId: process.env.VUE_APP_COGNITO_USERPOOLID || 'ap-northeast-1_3I24Z8G64',
    ClientId: process.env.VUE_APP_COGNITO_CLIENTID || 'r4ct3as7t7nhu9ji312gdgg1g',
    IdentityPoolId: process.env.VUE_APP_COGNITO_IDENTITYPOOLID || 'ap-northeast-1:4bcafda0-391c-4d88-8fee-517cb24cad0a',
}